import { camelCase, snakeCase } from 'lodash'


export function keysToCamelCase(o) {
  return keysTo(o, camelCase)
}

export function keysToSnakeCase(o) {
  return keysTo(o, snakeCase)
}

const isArray = function (a) {
  return Array.isArray(a)
}

const isObject = function (o) {
  return o === Object(o) && !isArray(o) && typeof o !== 'function'
}

const keysTo = function (o, convert) {
  if (isObject(o)) {
    const n = {}

    Object.keys(o)
      .forEach((k) => {
        n[convert(k)] = keysTo(o[k], convert)
      })

    return n
  } else if (isArray(o)) {
    return o.map((i) => {
      return keysTo(i, convert)
    })
  }

  return o
}